import { useTranslation } from 'react-i18next'
import type { ReactNode } from 'react'

import { HedefLogo } from '../components/HedefLogo'
import { ThemeToggle } from '../components/ThemeToggle'
import { LanguagePicker } from '../i18n/LanguagePicker'

/**
 * Kurumsal giris kabugu: solda marka paneli, sagda form.
 *
 * ## Mobilde panel EKRANI YEMIYOR
 *
 * `grid-template-columns: 1fr` tek basina YETMIYOR - satirlar da
 * tanimlanmali (`auto 1fr`), aksi halde iki satir esit boluniyor ve marka
 * paneli ekranin ucte birini kapliyor. Bu gercek bir hataydi.
 */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}) {
  const { t } = useTranslation()
  return (
    <div className="gate">
      <aside className="gate-brand">
        <span className="brand-lock">
          <HedefLogo height={26} />
        </span>
        <p className="gate-tagline">{t('auth.shell.tagline')}</p>
        <ul className="gate-points">
          <li>{t('auth.shell.point.local')}</li>
          <li>{t('auth.shell.point.background')}</li>
          <li>{t('auth.shell.point.persistent')}</li>
        </ul>
        {/*
          Dil secici GIRIS EKRANINDA: Turkce bilmeyen bir kullanici
          ayarlara ulasmak icin once giris yapmak zorunda kalirsa, giris
          ekranini okuyamadigi icin giremez. Kisir dongu tam burada
          kiriliyor. `persist` KAPALI - oturum yok.

          Tema kontrolu de burada, sohbet kenar cubugu ve ayarlarla AYNI
          bicimde - kullanicinin "tasarimlarda tema/dil ekran ekran farkli
          olmus, projede tek tip olmali" gerekcesi butun uygulamada gecerli.
        */}
        <span className="gate-prefs">
          <ThemeToggle variant="compact" showLabel />
          <LanguagePicker variant="compact" />
        </span>
      </aside>

      <main className="gate-panel">
        <div className="gate-card">
          <h1>{title}</h1>
          {subtitle && <p className="gate-sub">{subtitle}</p>}
          {children}
          {footer && <div className="gate-footer">{footer}</div>}
        </div>
      </main>
    </div>
  )
}

/** Form hatasi - tek yerden, `role="alert"` ile. */
export function FormError({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <p className="form-error" role="alert">
      {message}
    </p>
  )
}

/** Notr bilgi mesaji (enumeration'a karsi ayni metin). */
export function FormNotice({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <p className="form-notice" role="status">
      {message}
    </p>
  )
}
